import React from "react"

const TextArea = ({ field, form: { touched, errors }, ...props }) => {
  let status = "default"
  if (touched[field.name] && errors[field.name]) {
    status = "has-error"
  } else if (touched[field.name] && field.value && !errors[field.name]) {
    status = "is-fixed"
  }
  return (
    <div className={`TextArea ${status}`}>
      <textarea {...field} {...props} />
      {touched[field.name] &&
        errors[field.name] && (
          <div className="error-message">{errors[field.name]}</div>
        )}
    </div>
  )
}

export default TextArea
